import { create } from 'zustand'
import { api } from '../api/client'

interface PriceIncrease {
  date: string
  old_amount: number
  new_amount: number
  pct_change: number
}

interface Subscription {
  vendor: string
  status: string
  monthly_cost: number
  annual_cost: number
  avg_charge: number
  last_amount: number
  frequency: string
  charge_count: number
  account?: string
  category?: string
  last_charge?: string
  next_estimated?: string
  source?: string
  price_increases: PriceIncrease[]
  unused_score: number
  cancel_score: number
  transactions?: unknown[]
  // LLM-enhanced fields
  sub_type?: string
  llm_reasoning?: string
  cancel_reasons?: string[]
  action_recommendation?: 'keep' | 'cancel' | 'downgrade' | 'review'
  alternatives?: string[]
}

interface ReviewTxn {
  id: string; vendor: string; description: string; amount: number; date: string; category: string; flags?: string
}

interface AnalyzeState {
  subscriptions: Subscription[]
  reviewItems: ReviewTxn[]
  reviewCount: number
  loading: boolean
  error: string | null
  fetchSubscriptions: () => Promise<void>
  fetchReviewItems: () => Promise<void>
}

export const useAnalyzeStore = create<AnalyzeState>((set) => ({
  subscriptions: [],
  reviewItems: [],
  reviewCount: 0,
  loading: false,
  error: null,

  fetchSubscriptions: async () => {
    set({ loading: true, error: null })
    try {
      const data = await api.get<Subscription[]>('/api/subscriptions')
      set({ subscriptions: data, loading: false })
    } catch (e: unknown) {
      set({ error: (e as Error).message, loading: false })
    }
  },

  fetchReviewItems: async () => {
    try {
      const data = await api.get<ReviewTxn[]>('/api/review')
      set({ reviewItems: data, reviewCount: data.length })
    } catch (e: unknown) {
      set({ error: (e as Error).message })
    }
  },
}))
